import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CART_FEATURE } from '@b2b/features/cart/core/store/cart.states';
import { cartReducer } from '@b2b/features/cart/core/store/cart.reducer';
import { CartEffects } from '@b2b/features/cart/core/store/cart.effect';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(CART_FEATURE, cartReducer), EffectsModule.forFeature([CartEffects])],
})
export class CartStoreModule {}
